
import { StyleSheet } from 'aphrodite';
import { AppTheme, AppStyles } from './AppTheme';
import { AppHelper } from '../helpers/AppHelper';
import { CommonTheme, CommonStyles } from './Styles';
import { AppConfig } from '../AppConfig';
const IMG_RENDER_SIZE = 135
const HEIGHT = AppConfig.CUSTOM_STYLE ? 54 : 49
const ICON_SIZE = 35
const FIELD_HEIGHT = 49

export const CustomProductsStyles = StyleSheet.create({
})

export const CustomNoPermissionStyles = StyleSheet.create({
})

export const CustomMessageDialogStyles = StyleSheet.create({
})

export const CustomSearchBox = StyleSheet.create({
  inputStyle:{
    fontSize:14,
    height: 32
  },
  searchInput: {
    minWidth: 150,
    padding: 6,
    paddingLeft: 22,
    border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: 8,
    backgroundColor: 'white',
    marginBottom: 15
  },
  formControl: {
    margin: 0,
  },
  searchContainer: {
    // flex: 1
  }
})

export const CustomSingleSelectDropDownStyles = StyleSheet.create({
  container: {
    // minHeight: AppTheme.toolbarHeight * 2 / 3,
    display: 'flex',
    justifyContent: 'center',
    // width: '100%',
    // marginBottom: 16,
    maxWidth: AppTheme.viewPort,
  },
  inputStyle:{
    fontSize:14,
    height: 32
  },
  selectInput: {
    minWidth: 120,
    maxWidth: 120,
    // padding: 10,
    // paddingLeft: 22,
    // border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: 8,
    backgroundColor: 'white',
    height: 44,
    // marginTop: 10,
    '@media (max-width: 1024px)': {
      width: '100%',
      maxWidth: 'unset'
    },
  },
  searchInput: {
    minWidth: 150,
    padding: '6px 0px 6px 20px',
    paddingLeft: 22,
    // border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: 8,
    backgroundColor: 'white',
  },
  button: {
    background:'#FFFFFF',
    color: AppTheme.primaryColor,
    // border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg
  },
  formControl: {
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    },
    maxWidth: AppTheme.viewPort,
    width: '100%',
  },
  rightGridPadding: {
    paddingLeft: 19,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  innerContainer: {
    display: 'flex',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  searchContainer: {
    flex: 1
  },
  buttonInnerContainer: {
    paddingLeft: 10,
    minWidth: 130,
    '@media (max-width: 767px)': {
      flex: 1,
      paddingLeft: 0
    }
  },
  buttonText: {
    color: AppTheme.primaryColor,
    fontWeight: 600
  },
  progressIcon: {
    color: AppTheme.primaryColor
  },
  menuProps: {
    zIndex: 130000,
    marginTop: 5
  },
  paper: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
    // borderRadius: AppTheme.borderRadius,
    padding: '0px 10px'
  },
  textInputStyles: {
    // padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 14,
    margin: 0,
    padding: '10px 14px',
    ':focus': {
      backgroundColor: '#ffffff'
    }
  },
  singlePicker:{
    // paddingRight: 10
  },
  paperSelect: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
    padding: '0px'
  },
  showRecentButtonContainer: {
    textAlign: 'right',
    paddingLeft: '0',
    minWidth:'auto'
  },
  disabledInput: {
    backgroundColor: 'rgb(217, 217, 217)'
  },
  label: {
    fontSize: 14,
    color: '#121212',
    margin: '0px 0px 8px',
    fontWeight: 467
  }
})

export const CustomSearchBarStyles = StyleSheet.create({
  container: {
    // minHeight: AppTheme.toolbarHeight * 2 / 3,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 16,
    maxWidth: AppTheme.viewPort,
  },
  inputStyle:{
    fontSize:14,
    height: 32
  },
  selectInput: {
    minWidth: 150,
    padding: 10,
    paddingLeft: 22,
    // border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: 8,
    backgroundColor: 'white',
    height: 44
  },
  searchInput: {
    minWidth: 150,
    padding: '6px 0px 6px 20px',
    paddingLeft: 22,
    // border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: 8,
    backgroundColor: 'white',
  },
  button: {
    background:'#FFFFFF',
    color: AppTheme.primaryColor,
    // border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg,
    '@media (max-width: 1024px)': {
      width: '100%',
    },
  },
  formControl: {
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    },
    maxWidth: AppTheme.viewPort,
    width: '100%',
  },
  rightGridPadding: {
    paddingLeft: 19,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  innerContainer: {
    display: 'flex !important',
    gap: '10px',
    flexWrap: 'wrap',
    flexDirection: 'row',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  searchContainer: {
    flex: 1
  },
  buttonGroup:{
    display: 'flex',
    gap: 10,
    '@media (max-width: 1024px)': {
      flex: 1,
      paddingLeft: 0
    }
  },
  buttonInnerContainer: {
    // paddingLeft: 10,
    // minWidth: 130,
    '@media (max-width: 767px)': {
      flex: 1,
      paddingLeft: 0
    }
  },
  buttonText: {
    color: AppTheme.primaryColor,
    fontWeight: 600
  },
  progressIcon: {
    color: AppTheme.primaryColor
  },
  menuProps: {
    zIndex: 130000,
    marginTop: 5
  },
  paper: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
    // borderRadius: AppTheme.borderRadius,
    padding: '0px 10px'
  },
  textInputStyles: {
    // padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 14,
    margin: 0,
    ':focus': {
      backgroundColor: '#ffffff'
    }
  },
  singlePicker:{
    paddingRight: 10
  },
  paperSelect: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
    padding: '0px'
  },
  showRecentButtonContainer: {
    textAlign: 'right',
    paddingLeft: '0',
    minWidth:'auto'
  }
})

export const CustomSearchBarStylesVenue = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 16,
    maxWidth: 800
  },
  searchInput: {
    fontSize:14,
    minWidth: 150,
    padding: 10,
    paddingLeft: 22,
    border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: AppTheme.borderRadius,
    backgroundColor: 'white',
    height: 44
  },
  button: {
    background: '#ffffff',
    color: AppTheme.primaryColor,
    // border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg
  },
  formControl: {
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    },
    maxWidth: AppTheme.viewPort,
    width: '100%',
  },
  rightGridPadding: {
    paddingLeft: 19,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  innerContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      gap: 10
    }
  },
  searchContainer: {
    flex: 1
  },
  buttonInnerContainer: {
    paddingLeft: 10,
    minWidth: 130,
    '@media (max-width: 767px)': {
      flex: 1,
      paddingLeft: 0
    }
  },
  buttonText: {
    color: AppTheme.primaryColor,
    fontWeight: 600
  },
  progressIcon: {
    color: AppTheme.primaryColor
  },
  showRecentButtonContainer: {
    paddingLeft: '0',
    minWidth:'auto'
  }
})

export const CustomMultiSelectSearchBarStyles = StyleSheet.create({
  container: {
    // minHeight: AppTheme.toolbarHeight * 2 / 3,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 16,
    maxWidth: AppTheme.viewPort,
  },
  selectStyle: {
    minWidth: 150,
    padding: '0px !important',
    // border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: 8,
    backgroundColor: 'white',
    minHeight: '44px !important',
    fontSize:14
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    },
    maxWidth: AppTheme.viewPort,
    width: '100%',
  },
  innerContainer: {
    display: 'flex',
    '@media (max-width: 1024px)': {
      flexDirection: 'row',
      gap: 10
    }
  },
  searchContainer: {
    flex: 1
  },
  buttonInnerContainer: {
    paddingLeft: 10,
    minWidth: 130,
    '@media (max-width: 767px)': {
      flex: 1,
      paddingLeft: 0
    },
    '@media (max-width: 1024px)': {
      minWidth: 'unset'
    }
  },
  buttonText: {
    color: AppTheme.primaryColor,
    fontWeight: 600
  },
  progressIcon: {
    color: AppTheme.primaryColor
  },
  button: {
    background: '#FFFFFF',
    color: AppTheme.primaryColor,
    // border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg,
    '@media (max-width: 1024px)': {
      minWidth: 'unset',
      width: '100%'
    }
  },
  textBoxContainer: {
    display: 'flex',
    flexDirection: 'column',
    // marginBottom: 32,
  },
  textFeildStyle: {
    minHeight: 54,
    borderRadius: 16,
    backgroundColor: '#F6F6F8',
  },
  textInputStyles: {
    border: 'none',
    padding: '0px 14px',
    flex: 1,
    textAlign: 'left',
    fontSize: 14,
    color: '#000000',
    '::placeHolder': {
      color: '#747474',
    },
    height: 44
  },
  selectInputStyles: {
    fontSize: 14,
    color: '#000000',
    margin: 0,
    height: 44
  },
  showRecentbutton:{
    background: '#ffffff',
    color: AppTheme.primaryColor,
    // border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg,
    display: 'inline-flex',
    '@media (max-width: 1024px)': {
      minWidth: 'unset',
      width: '100%'
    }
  },
  showRecentButtonContainer: {
    textAlign: 'right',
    paddingLeft: '0',
    minWidth:'auto',
    '@media (max-width: 767px)': {
      textAlign: 'left'
    }
  }
})

export const CustomBreadCrumbsStyles = StyleSheet.create({
  breadCrumbsContainer:{
    '@media (max-width: 1024px)': {
      display: 'none'
    }
  },
  textStyle: {
    //backgroundColor: AppTheme.primaryColor,
    //padding: '2px 12px',
    color: 'grey',
    fontSize: 18,
    textTransform: 'capitalize',
    borderRadius: 12,
    '&:hover, &:focus': {
      //backgroundColor: AppTheme.primaryColor,
      cursor: 'pointer'
    },
    '&:active': {
      //backgroundColor: emphasize(AppTheme.primaryColor),
    },
  },
  lastTextStyle: {
    color: 'grey',
    fontSize: 18,
    textTransform: 'capitalize'
  },
  link: {
    textDecoration: 'none'
  }
})

export const CustomImageUploaderStyles = StyleSheet.create({
  container: {
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 0,
  },
  fitContainer: {
    height: HEIGHT,
    width: 'auto'
  },
  fileInput: {
    width: '100%'
  },
  textButton: {
    backgroundColor: 'black',
    color: 'white',
    maxWidth: 100,
    minHeight: 24,
    textAlign: 'center',
    marginTop: 5,
    fontSize: 10
  },
  text: {
    marginTop: 10,
    marginBottom: 3,
    fontSize: 12
  },
  textUpload: {
    color: 'black',
  },
  textError: {
    color: '#f44336',
  },
  textSuccess: {
    color: 'green',
  },
  editor: {
    width: 65,
    height: 65,
  },
  imgContainer: {
    display: 'none'
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  imageContent: {
    width: '100%',
    borderRadius: 8,
    maxWidth: '100%',
    maxHeight: '100%'
  },
  closeIconContainer: {
    backdropFilter: 'blur(6px)',
    backgroundColor: 'white',
    display: 'flex',
    cursor: 'pointer',
    border: '1px solid black',
    padding: 2,
    borderRadius: 4,
    marginLeft: 10
  },
  closeIconDisableContainer: {
    backgroundColor: '#f5f5f5',
    cursor: 'default',
  },
  attachFileText: {
    margin: 0,
    fontSize: 11,
    color: 'black',
    marginLeft: 13
  },
  attachFile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 10
  },
  labelContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
    cursor: 'pointer',
    padding: 0,
    borderRadius: 0,
    alignItems: 'center'
  },
  labelDisableContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
    padding: 0,
    backgroundColor: '#d9d9d9',
    cursor: 'unset',
    borderRadius: 0,
    alignItems: 'center'
  },
  attachFileTextBrowse: {
    color: AppTheme.primaryColor,
    fontWeight: 500
  },
  outerMainContainer: {
    display: 'flex'
  },
  outerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    border: '1px dashed #E5E5E5',
    borderRadius: 8,
    height: HEIGHT,
    position: 'relative',
    overflow: 'hidden'
  },
  outerContainerDisabled: {
    backgroundColor: '#d9d9d9'
  },
  imageOuterContainer: {
    flex: 'unset',
    border: '1px solid #E5E5E5'
  },
  imageIconContainer: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  imageIconOuterContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row'
  },
  fileDrop: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    position: 'relative'
  },

  targetFileDrop: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  reuploadContainer: {
    fontSize: 16,
    color: AppTheme.primaryColor,
    margin: 20,
    display: 'flex',
    alignItems: 'center'
  },
  reuploadLabel: {
    cursor: 'pointer'
  },
  deleteIconContainer: {
    margin: '0px 10px'
  }
})

export const CustomAssetPickerStyles = StyleSheet.create({
  container: {
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  text: {
    marginTop: 10,
    marginBottom: 3,
    fontSize: 12
  },
  textSuccess: {
    color: 'green',
  },
  closeIconContainer: {
    backdropFilter: 'blur(6px)',
    backgroundColor: 'white',
    display: 'flex',
    cursor: 'pointer',
    border: '1px solid black',
    padding: 2,
    borderRadius: 4,
  },
  closeIconDisableContainer: {
    backgroundColor: '#f5f5f5',
    cursor: 'default',
  },
  labelContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
    cursor: 'pointer',
    padding: 0,
    borderRadius: 0,
    alignItems: 'center'
  },
  outerMainContainer: {
    display: 'flex'
  },
  imageOuterContainer: {
    // flex: 'unset',
    border: '1px solid #E5E5E5'
  },
  deleteIconContainer: {
    margin: '0px 5px'
  },
  assetPicketOuterContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px dashed #E5E5E5',
    borderRadius: 8,
    height: 49,
    position: 'relative',
    overflow: 'hidden',
    marginRight: 10
  },
  assetPickerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'whitesmoke',
    flex: '1 1 0%',
    padding: 0,
    cursor: 'pointer',
    borderRadius: 8,
    maxWidth: 125,
    minHeight: 51
  },
  assetPickerTitle: {
    textAlign: 'center',
    fontSize: 12
  },
  selectedItemsTitle: {
    fontSize: '10px !important',
    maxWidth: '120px !important',
    padding: '0px 10px !important',
    textOverflow: 'ellipsis !important',
    overflow: 'hidden',
    lineBreak: 'anywhere',
    whiteSpace: 'nowrap'
  },
  assetsImageContent: {
    borderRadius: 8,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    marginLeft: 1
  },
  icons:{
    color: 'lightgray',
    padding: '0px 12px'
  }
})

export const CustomTableComponentStyles = StyleSheet.create({
  content: {
    paddingBottom: 0
  },
  divTable: {
    paddingBottom:40,
    display: 'block',
    // overflowX: 'auto',
    width: '100%',
    '@media (max-width: 320px)': {
      maxWidth: '92vw',
      overflowX: 'auto'
    },
    '@media (max-width: 767px) and (min-width: 321px)': {
      maxWidth: '94vw',
      overflowX: 'auto'
    },
    '@media (min-width: 768px) and (max-width: 1021px)': {
      maxWidth: 750,
    },
  },
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 20px',
  },
  entityAddIcon: {
    fontSize: 36,
    color: 'black',
    cursor: 'pointer',
  },
  cellHead: {
    // backgroundColor: 'white',
    // color: '#9B9B9B',
    // height: 38,
    // fontSize: 14,
    // fontWeight: 'bold',
    // padding: '8px 8px 8px 8px',
    border:'none',
    fontSize: 14,
    color: '#121212',
    fontWeight:400,
    padding: '0px 8px',
    height: 10,
    lineHeight: 2
  },
  cellBodyIcons: {
    borderTopRightRadius: 16,
    borderBottomRightRadius: 16,
  },
  cellBody: {
    backgroundColor: 'white',
    color: '#4A4A4A',
    minHeight: 72,
    border: '1px solid #FFFFFF',
    fontSize: 14,
    padding: '26px 8px 26px 8px',
    verticalAlign: 'middle'
  },
  firstcellBody: {
    borderTopLeftRadius: 16,
    borderBottomLeftRadius: 16,
    paddingLeft: 20
  },
  divIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginRight: 8
  },
  firstCheckHeaderCell: {
    borderTopLeftRadius: 16,
    borderBottomLeftRadius: 16
  },
  endCheckHeaderCell: {
    borderTopRightRadius: 16,
    borderBottomRightRadius: 16
  },
  checkBoxRow:{

  },
  checkAllCell:{
    background: 'none !important',
    border: 'none !important',
    padding: '0px !important',
    fontSize: 14
  },
  singleCheckboxCell:{
    padding: ''
  },
  rowCheckBox:{
    padding: 0
  },
  draggingRow:{
    display: 'table'
  },
  emptyViewMessage:{
    backgroundColor:'#dededecc'
  },
  fullCellBodyLoader:{
    borderRadius: 16,
    textAlign: 'center',
    border: 'none'
  },
  emptyMessageDnd:{
    background: '#fff',
    fontSize: 20
  },
  emptyTableDnd:{
    height: window.innerHeight - 300,
    background: '#fff'
  },
  showInFullHeight:{
    minHeight:'80%',
    justifyContent: 'space-between',
  },
  droppableSection:{
    width: '100%',
    minHeight: window.innerHeight - 300,
  },
  selectionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },

  selectionInfo: {
    display: 'flex',
    alignItems: 'center',
  },

  selectionActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginRight:'-2rem'
  },

  checkboxActionButton: {
    marginLeft: 10,
  },
})

export const CustomSEStyles = StyleSheet.create({
  container: {
    background: 'white',
    height: '100%',
    borderRadius: AppTheme.borderRadius,
  },
  content: {
    padding: AppTheme.pagePadding * 4,
  },
  contentForRow: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  labelContainerForRow: {
    paddingBottom: 20,
    width: '46%',
    '@media (max-width: 767px)': {
      width: '100%'
    }
  },
  dividerForRow: {
    width: '8%',
    '@media (max-width: 767px)': {
      width: '0%',
      display: 'none'
    }
  },
  heading: {
    borderBottom: '1px solid lightgray',
  },
  headingContent: {
    padding: AppTheme.pagePadding * 4,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  editButton: {
    color: AppTheme.primaryColor,
    background: 'none',
    fontWeight: 600,
    padding: 0,
    fontSize: 16,
    textTransform: 'none',
    minWidth: 'auto',
    ':hover': {
      background: 'none',
      //backgroundColor: 'none',
    }
  },
  stepFormTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    margin: 0,
    textTransform: 'capitalize'
  },
  label: {
    fontSize: 14,
    color: 'grey',
    marginBottom: 2,
    marginTop: 0
  },
  value: {
    margin: 0,
    fontSize: 14,
    color: '#222222',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  valueDisplayMultiline: {
    whiteSpace: 'normal'
  },
  actionIcon: {
    color: AppTheme.primaryColor
  },
  imageContainer: {
    width: 'fit-content',
    height: 50,
    border: '1px solid #E2EAFC',
    borderRadius: 8,
    overflow: 'hidden'
  },
  imageContent: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  link: {
    color: AppTheme.primaryColor,
    textDecoration: 'none',
    borderBottom: '0.5px solid ' + AppTheme.primaryColor,
    width: 'fit-content'
  },
  buttonText: {
    color: AppTheme.primaryColor,
    fontWeight: 600
  },
  labelContainer: {
    paddingBottom: 20
  },
})

export const CustomNextPageStyles = StyleSheet.create({
})

export const CustomHeaderbarStyles = StyleSheet.create({
})

export const CustomOrgSwitcherStyles = StyleSheet.create({
})

export const CustomSettingsMenuStyles = StyleSheet.create({
})

export const CustomDynamicFormDialogStyles = StyleSheet.create({
  modalHeader: {
    padding: 25,
    paddingBottom: 10
  },
  modalTitle: {
    color: 'black',
    fontSize: 28,
    fontWeight: 600
  },
  modalContent: {
    paddingLeft: 25,
    paddingRight: 25,
    // marginTop: 20
  },
  modalCloseButton: {
    position: 'absolute',
    top: 33,
    right: 30,
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer'
  },
  modalCloseIcon: {
    width: 18,
    height: 18
  },

  customRoot: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(10px)',
    zIndex: 13000
  },
  customPaper: {
    borderRadius: 16,
    // minWidth: 600,
    backgroundColor: AppTheme.secondaryBg,
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  }
})

export const CustomDynamicFormStyles = StyleSheet.create({
  linkLabel: {
    fontSize: 14,
    margin: 0,
    marginBottom: 8,
    color: '#2029f1',
    textDecoration: 'none'
  },
  linkLabelContainer: {
    display: 'flex',
    gap: 5
  },
  dropdownOptionCard: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '18px 22px',
    margin: '8px 0',
    backgroundColor: '#FFFFFF',
    borderRadius: 14,
    border: '1px solid #E5E5E5',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.08)',
    boxSizing: 'border-box'
  },
  dropdownOptionTitle: {
    fontSize: 18,
    lineHeight: '26px',
    fontWeight: 700,
    color: '#202020',
    marginBottom: 10
  },
  dropdownOptionLine: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#555555',
    marginBottom: 4
  },
  dropdownOptionLineBold: {
    fontWeight: 'bold'
  },
  dropdownOptionAddress: {
    fontSize: 15,
    lineHeight: '24px',
    fontWeight: 300,
    color: '#7B7B7B',
    marginBottom: 4
  },
  dropdownOptionSubMeta: {
    fontSize: 13,
    lineHeight: '20px',
    fontWeight: 300,
    color: '#A0A0A0'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // padding: AppTheme.pagePadding,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    }
  },
  leftGridPadding: {
    paddingRight: 10,
    '@media (max-width: 767px)': {
      paddingRight: 0,
    }
  },
  rightGridPadding: {
    paddingLeft: 10,
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  errorMsg: {
    paddingRight: 20,
    color: '#f44336'
  },
  successMsg: {
    paddingRight: 20,
    color: 'green'
  },
  marginLeft: {
    color: 'white'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 20,
    marginBottom: 30
  },
  pendingApprovalLabel: {
    marginTop: 0,
    marginBottom: 0,
    color: 'orange',
    fontSize: 10
  },
  openDoc: {
    marginTop: 0,
    marginBottom: 0,
    color: 'black',
    fontSize: 10,
    cursor: 'pointer',
  },
  uploadFieldLabel: {
    marginTop: 10,
  },
  buttonDelete: {
    background: '#FF0D0D'
  },
  label: {
    fontSize: 14,
    color: '#121212',
    margin: 0,
    marginBottom: 8,
    fontWeight: '467'
  },
  formControl: {
    borderRadius: 8,
    border: 'none',
    background: '#F7F7F9',
    overflow: 'hidden'
  },
  textInput: {
    padding: '4px 0px'
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16
  },
  textInputStylesDisabled: {
    backgroundColor: '#d9d9d9',
  },
  pickerStyle: {
    marginTop: 0
  },
  pickerInputStyles: {
    padding: '8px 20px !important',
    flex: '1 1 0% !important',
    textAlign: 'left !important',
    color: 'rgb(34, 34, 34) !important',
    fontSize: '16px !important',
    borderRadius: '8px !important',
    overflow: 'hidden !important',
    background: '#f7f7f9'
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  tag: {
    backgroundColor: '#e0e0e0',
    color: '#222222',
    fontSize: 13,
    borderRadius: 8,
    height: 26
  },
  popupIndicator: {
    marginRight: 5,
  },
  dialog: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
  },

  modalCloseIcon: {
    width: 12,
    height: 12,
    padding: 1,
    borderRadius: 6
  },

  fieldOuterContainer: {
    display: 'flex'
  },
  fieldLeftInnerContainer: {
    flex: 1,
    paddingRight: 10,
    '@media (max-width: 767px)': {
      paddingRight: 0,
    }
  },
  fieldRightInnerContainer: {
    flex: 1,
    paddingLeft: 10,
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  delFieldContainer: {
    width: '25%',
    marginRight: 20
  },
  formControlMain: {
    marginTop: 0,
    marginBottom: 0
  },
  optionImageContainer: {
    width: 20,
    height: 20,
  },
  optionImage: {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%'
  },
  optionImageContainerSpec: {
    marginRight: 9,
    marginLeft: 5
  },
  textFieldHelperText: {
    color: '#000000',
    fontSize: 14,
    alignSelf: 'flex-end',
    position: 'absolute',
    right: 10,
    bottom: 0
  },
  charCounter: {
    margin: 0
  },
  deleteInputStyle:{
    height: 8
  },
  optionLoaderSpinner:{
    marginRight: 15
  },
  addOptionStyle: {
    color: AppTheme.buttonBg
  },
  deleteInputBoxStyle:{
    border: 'solid 1px #a2a2a2'
  }
})

export const CustomDocumentUploaderStyles = StyleSheet.create({
  container: {
    // minHeight: 52,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: 1,
  },
  buttonContainer: {
    height: FIELD_HEIGHT,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    border: '1px solid #E5E5E5',
    borderRadius: AppTheme.borderRadius,
    position: 'relative',
  },
  buttonContainerDisabled: {
    backgroundColor: '#d9d9d9'
  },
  fileInput: {
    width: '100%'
  },
  button: {
    backgroundColor: AppTheme.primaryColor,
    borderRadius: AppTheme.borderRadius,
    display: 'flex',
    alignItems: 'center',
    // minWidth: 150,
    padding: '5px 15px',
    fontSize: 10,
    color: AppTheme.secondaryBg
  },
  text: {
    fontSize: 12,
    margin: 0,
    marginRight: 10,
  },
  textUpload: {
    color: 'black',
  },
  textError: {
    color: '#f44336',
  },
  textSuccess: {
    color: 'green',
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    cursor: 'pointer',
    borderRadius: AppTheme.borderRadius
  },
  labelDisableContainer: {
    backgroundColor: '#d9d9d9',
    cursor: 'unset',
  },
  attachFile: {
    marginRight: 10,
    color: AppTheme.primaryColor,
    minWidth: 160
  },
  closeIconContainer: {
    color: AppTheme.primaryColor,
    marginRight: 10
  },
  openDoc: {
    marginTop: 0,
    marginBottom: 0,
    color: '#7d7d7d',
    fontSize: 10,
    textDecoration: 'none',
    borderBottom: '0.5px solid #7d7d7d'
  },
  msgContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 5
  },
  imageIconOuterContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row'
  },
  imageIconContainer: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    display: 'flex',
    marginRight: 10
  },
  imageContent: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  fileContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    padding: '4px 15px'
  },
  targetContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  documentContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center'
  },
  documentImageContainer: {
    width: ICON_SIZE,
    height: ICON_SIZE,
  },
  closeImgContainer: {
    display: 'flex',
    cursor: 'pointer',
    color: '#222222',
    border: '1px solid' + '#222222',
    borderRadius: 4,
    padding: 2
  },
  closeImgDisableContainer: {
    backgroundColor: '#f5f5f5',
    cursor: 'default',
  },
  documentNameContainer: {
    lineHeight: 'unset',
    margin: 0,
    display: 'grid'
  },
  docName: {
    fontSize: 16,
    color: '#222222',
    margin: 0,
    alignItems: 'center',
    marginLeft: 10,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  attachFileText: {
    fontSize: 11,
    color: '#222222',
    //fontWeight: 500,
    margin: 0
  },
  attachFileTextBrowse: {
    color: AppTheme.primaryColor,
    fontWeight: 500
  },
  reuploadIconContainer: {
    right: 36
  },
  delImgContainer: {
    margin: '0px 10px'
  }
})

export const CustomBaseEnityStyles = StyleSheet.create({

})
export const CustomCampaignAdvertiserStyles = StyleSheet.create({
  img: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
    borderRadius: 10,
    overflow: 'hidden',
    border: '1px solid #d3d3d3'
  },
  pageContainer: {
    display: 'flex',
    flex: 1,
    gap: 20,
    flexDirection: 'column',
    paddingBottom: 40,
    '@media (max-width: 767px)': {
      marginLeft: 10,
      marginRight: 10,
    }
  },
  buttonStyle: {
    background: 'transparent',
    border: '1px solid ' + AppConfig.TINT_COLOUR,
    borderRadius: 8,
  },
  imgNameContainer: {
    height: 75,
    width: 75
  },
  imgName: {
    color: '#3FA5D6'
  },
  paymentContainer: {
    padding: 0,
    borderRadius: 16,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 20,
    gap: 20,
    flex: 1,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'flex-end',
    }
  },
  mobTableGraphicDetail: {
    display: 'flex',
    flexDirection: 'column'
  },
  paper: {
    maxWidth: 'unset',
    minWidth: '75dvw',
    zIndex: 11,
    width: '100%',
    height: '90dvh',
    '@media (max-width: 767px)': {
      minWidth: '90dvw'
    },
    borderRadius: 40
  },
  closeContainer: {
    marginBottom: 10,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '20px 40px 0px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    position: 'absolute'
  },
  modalTitle: {
    color: 'black',
    fontSize: 26,
    fontWeight: 600,
    margin: 0
  },
  modalCloseButton: {
    position: 'absolute',
    top: 33,
    right: 30,
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer'
  },
  modalCloseIcon: {
    width: 18,
    height: 18
  },
  modalHeader: {
    padding: 25,
    paddingBottom: 20
  },
  customRoot: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(10px)',
    zIndex: 13000
  },
  customPaper: {
    borderRadius: 40,
    minWidth: 500,
    minHeight: 500,
    backgroundColor: AppTheme.secondaryBg,
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 767px)': {
      borderRadius: 0,
      minWidth: 'unset',
    },
  },
  modalContent: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  title: {
    fontSize: 26,
    margin: 0
  },
  buttonTextStyle: {
    fontSize: 16,
    fontWeight: 700,
    margin: 0,
    color: '#FFFFFF',
    '@media (max-width: 767px)': {
      fontSize: 16,
    }
  },
  actionButton: {
    minWidth: 155
  },
  cancelInfo: {
    margin: 0,
    color: '#D10000'
  },
  cancelButton: {
    background: '#FFFFFF'
  },
  cancelButtonTextStyle: {
    color: AppConfig.TINT_COLOUR
  },
  priceContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  //payment url dialog
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    paddingTop: 0,
    paddingLeft: 25,
    paddingRight: 25,
  },
  dialogTitle: {
    marginBottom: 20
  },
  generatedLink: {
    marginTop: 20
  },
  paymentUrlDialogcustomPaper: {
    borderRadius: 16,
    // minWidth: 600,
    backgroundColor: AppTheme.secondaryBg,
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  generatedLinkContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  amount: {
    fontSize: 16
  },
  paymentLnkContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    padding: 10,
    borderRadius: 12,
    cursor: 'pointer'
  },
  paymentLink: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%'
  },
  price: {
    fontSize: 24,
    fontWeight: 600,
    color: '#1B1B1B',
    margin: 0
  },
})

export const CustomPreviewDialogStyles = StyleSheet.create({
})

export const CustomAppButtonStyles = StyleSheet.create({
  button: {
    background: 'linear-gradient(90deg, rgba(32,41,241,1) 0%, rgba(0,8,190,1) 100%)',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    height: 44,
    minWidth: 120,
    padding: 13,
    fontSize: 14,
    textTransform: 'capitalize',
    color: AppTheme.buttonTextColor
  },
  buttonText: {
    fontSize: 14,
    margin: 0,
    textTransform: 'none',
    color: AppTheme.tintContrastColour,
    fontWeight: 'bold',
    '@media (max-width: 767px)': {
      fontSize: 12,
    },
  },
  progressIcon: {
    color: '#FFFFFF',
  },
  iconContainer: {
    // display: 'flex',
    alignItems: 'center',
    marginRight: 10,
    display: 'none'
  }
})

export const CustomColourPickerStyles = StyleSheet.create({
})

export const CustomCardsStyles = StyleSheet.create({
})


// WEBPACK FOOTER //
// ./src/styles/CustomStyles.js